import React from "react";
import CustomScrollbars from './CustomScrollbars/CustomScrollbars';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class TextOutputBlock extends React.Component {
    rtl = ['ar', 'he', 'fa', 'ur'];
    render() {
        const text = this.props.text ? this.props.text : null;
        const files = this.props.files ? this.props.apiEndpoint + '/'+ this.props.files : null;
        return (
            <div className="amt-input-text" style={{...this.props.styled.outputText,padding:"10px 15px 10px 15px"} || {}}>
                {
                    !files ? (
                        <CustomScrollbars style={{
                            width: "100%",
                            height: 83
                        }} document={this.props.document}>
                            <div className="output-text" style={{whiteSpace:"pre-line"}} dir={  this.rtl.includes(this.props.tgtLang.id)
                    ? 'rtl'
                    : 'ltr'}>
                                {text ? text : <span className="output-placeholder">Translation...</span>}
                            </div>
                        </CustomScrollbars>
                    ) : (
                        <div className="output-wrapper">
                            <div className="output-files">
                                <h5>Your translation is completed! Please download your document on the link below.</h5>
                                <br />
                                <button /* href={files + '?SSMTKey=' + this.props.apiKey} */ className="translated-link" download target="_blank"
                                   onClick={() => {
                                      // this.props.dow(this.props.files[0].fileId)
                                       for (const i in this.props.files) {
                                        this.props.dow(this.props.files[i].fileId)
                                       }
                                       this.removeLink()}}>
                                    <FontAwesomeIcon className="download-icon" icon="file-download"/>
                                    DOWNLOAD TRANSLATION
                                </button>
                            </div>
                        </div>
                    )
                }

            </div>
        );
    }

    removeLink() {

        this.props.resetLink();
    }
}
